import { v3 } from '@adobe/edex/frontend/api/v3';
import { addSourceInfoToPayload, getNavSource } from '@adobe/edex/ui/shared/utils';

const baseURL = '/analytics';

export function track(
  paramsArray: {
    event: string;
    payload: {
      id?: string;
      url?: string;
      mvParams?: {
        cid?: string;
        cname?: string;
        cqueryParameter?: string;
        mv?: string;
        mvDetail?: string;
        landingPage?: string;
      };
    };
  }[]
) {
  paramsArray?.forEach((param) => {
    param.payload = addSourceInfoToPayload(param.payload, getNavSource());
  });

  return v3.post(`${baseURL}/track`, { events: paramsArray });
}
